export default `<asset-store class="asset-store" tabindex="0" sidebar-mode starting-search-type="{{autoLoadStore}}"></asset-store> `;